<template>
  <div data-v-5e89786c="" class="contents">
    <nav data-v-5e89786c="" class="nav_mobile_top">
      <div data-v-5e89786c="" class="nav_content">
        <div data-v-5e89786c="" class="nav_left nav_left1">
          <div data-v-5e89786c="" class="back" @click="$router.go(-1)">
            <img
              data-v-5e89786c=""
              src="../../assets/img/arrow_back.d5eef796-0de7d3ca.svg"
              alt=""
            />
          </div>
          <div data-v-5e89786c="" class="nav_name2">
            {{ $t('contractorder') }}
          </div>
          <div data-v-5e89786c="" class="start"></div>
        </div>
      </div>
    </nav>
    <div data-v-5e89786c="" class="empty-box"></div>
    <van-loading
      class="loading"
      type="spinner"
      v-if="showloading"
      color="#c2e22a"
    />
    <div
      data-v-5e89786c=""
      class="contents-box"
      style="padding: 0px 20px"
      v-else
    >
      <div data-v-5e89786c="" class="menu-list">
        <div data-v-5e89786c="" class="menus">
          <div
            data-v-5e89786c=""
            class="menu"
            :class="selectop == 1 ? 'menu_active' : ''"
            @click="changesel(1)"
          >
            {{ $t('normalls') }}
          </div>
          <div
            data-v-5e89786c=""
            class="menu"
            :class="selectop == 2 ? 'menu_active' : ''"
            @click="changesel(2)"
          >
            {{ $t('enddd') }}
          </div>
        </div>
      </div>
      <div data-v-5e89786c="" v-if="selectop == 1">
        <div data-v-a330c516="" class="no-data" v-if="empty1">
          <div data-v-a330c516="" class="no-img">
            <img
              data-v-a330c516=""
              src="../../assets/img/no_data.78bef72c.svg"
              alt=""
              srcset=""
            />
          </div>
          <div data-v-a330c516="" class="no-title">{{ $t('aiyass') }}</div>
          <div data-v-a330c516="" class="no-info">
            {{ $t('hasnoorder') }}
          </div>
        </div>
        <div data-v-5e89786c="" v-else>
          <div data-v-1ae69322="" class="content-list" v-for="item in list">
            <div data-v-1ae69322="" class="title">{{ item.symbol }}</div>
            <div data-v-1ae69322="" class="list">
              <div data-v-1ae69322="" class="lable">
                {{ $t('dingdanbianhao') }}
              </div>
              <div data-v-1ae69322="" class="list-content">
                {{ item.orderid }}
              </div>
            </div>
            <div data-v-1ae69322="" class="list">
              <div data-v-1ae69322="" class="lable">{{ $t('leixing') }}</div>
              <div
                data-v-1ae69322=""
                class="list-content list-content2"
                v-if="item.direction === 1"
              >
                {{ $t('zuoduo') }}
              </div>
              <div
                data-v-1ae69322=""
                class="list-content list-content2"
                v-if="item.direction === 2"
              >
                {{ $t('zuokong') }}
              </div>
              <!---->
            </div>
            <div data-v-1ae69322="" class="list">
              <div data-v-1ae69322="" class="lable">
                {{ $t('caozhengjin') }}
              </div>
              <div data-v-1ae69322="" class="list-content">
                {{ item.earnestmoney }}
              </div>
            </div>
            <div data-v-1ae69322="" class="list">
              <div data-v-1ae69322="" class="lable">{{ $t('jiaofeee') }}</div>
              <div data-v-1ae69322="" class="list-content">
                $ {{ item.fee }}
              </div>
            </div>
            <div data-v-1ae69322="" class="list">
              <div data-v-1ae69322="" class="lable">{{ $t('beishush') }}</div>
              <div data-v-1ae69322="" class="list-content">
                {{ item.ggan }} X
              </div>
            </div>
            <div data-v-1ae69322="" class="list">
              <div data-v-1ae69322="" class="lable">
                {{ $t('shoushoushu') }}
              </div>
              <div data-v-1ae69322="" class="list-content">{{ item.num }}</div>
            </div>
            <div data-v-1ae69322="" class="list" v-if="item.type === 1">
              <div data-v-1ae69322="" class="lable">{{ $t('weituojiaa') }}</div>
              <div data-v-1ae69322="" class="list-content">
                {{ item.wt_price }}
              </div>
            </div>
            <div data-v-1ae69322="" class="list">
              <div data-v-1ae69322="" class="lable">{{ $t('kaicccpp') }}</div>
              <div data-v-1ae69322="" class="list-content">
                {{ item.price }}
              </div>
            </div>
            <div data-v-1ae69322="" class="list">
              <div data-v-1ae69322="" class="lable">{{ $t('pingcpp') }}</div>
              <div data-v-1ae69322="" class="list-content">
                {{ item.pc_price }}
              </div>
            </div>
            <div data-v-1ae69322="" class="btn_box" v-if="item.type === 1">
              <span
                data-v-1ae69322=""
                class="pcbtn"
                @click="cancleorder(item.id)"
                >{{ $t('cxxdd') }}</span
              ><!---->
            </div>
            <div data-v-1ae69322="" class="btn_box" v-if="item.type === 2">
              <span
                data-v-1ae69322=""
                class="pcbtn"
                @click="pcorder(item.id)"
                >{{ $t('yijianpc') }}</span
              ><!---->
            </div>
          </div>
        </div>
        <!---->
      </div>
      <div data-v-5e89786c="" v-if="selectop == 2">
        <div data-v-a330c516="" class="no-data" v-if="empty2">
          <div data-v-a330c516="" class="no-img">
            <img
              data-v-a330c516=""
              src="../../assets/img/no_data.78bef72c.svg"
              alt=""
              srcset=""
            />
          </div>
          <div data-v-a330c516="" class="no-title">{{ $t('aiyass') }}</div>
          <div data-v-a330c516="" class="no-info">
            {{ $t('hasnoorder') }}
          </div>
        </div>
        <div data-v-5e89786c="" v-else>
          <div data-v-1ae69322="" class="content-list" v-for="item in list2">
            <div data-v-1ae69322="" class="title">{{ item.symbol }}</div>
            <div data-v-1ae69322="" class="list">
              <div data-v-1ae69322="" class="lable">
                {{ $t('dingdanbianhao') }}
              </div>
              <div data-v-1ae69322="" class="list-content">
                {{ item.orderid }}
              </div>
            </div>
            <div data-v-1ae69322="" class="list">
              <div data-v-1ae69322="" class="lable">{{ $t('leixing') }}</div>
              <div
                data-v-1ae69322=""
                class="list-content list-content2"
                v-if="item.direction === 1"
              >
                {{ $t('zuoduo') }}
              </div>
              <div
                data-v-1ae69322=""
                class="list-content list-content2"
                v-if="item.direction === 2"
              >
                {{ $t('zuokong') }}
              </div>
              <!---->
            </div>
            <div data-v-1ae69322="" class="list">
              <div data-v-1ae69322="" class="lable">
                {{ $t('caozhengjin') }}
              </div>
              <div data-v-1ae69322="" class="list-content">
                {{ item.earnestmoney }}
              </div>
            </div>
            <div data-v-1ae69322="" class="list">
              <div data-v-1ae69322="" class="lable">{{ $t('jiaofeee') }}</div>
              <div data-v-1ae69322="" class="list-content">
                $ {{ item.fee }}
              </div>
            </div>
            <div data-v-1ae69322="" class="list">
              <div data-v-1ae69322="" class="lable">{{ $t('beishush') }}</div>
              <div data-v-1ae69322="" class="list-content">
                {{ item.ggan }} X
              </div>
            </div>
            <div data-v-1ae69322="" class="list">
              <div data-v-1ae69322="" class="lable">
                {{ $t('shoushoushu') }}
              </div>
              <div data-v-1ae69322="" class="list-content">{{ item.num }}</div>
            </div>
            <div data-v-1ae69322="" class="list">
              <div data-v-1ae69322="" class="lable">{{ $t('kaicccpp') }}</div>
              <div data-v-1ae69322="" class="list-content">
                {{ item.price }}
              </div>
            </div>
            <div data-v-1ae69322="" class="list">
              <div data-v-1ae69322="" class="lable">{{ $t('pingcpp') }}</div>
              <div data-v-1ae69322="" class="list-content">
                {{ item.pc_price }}
              </div>
            </div>
            <div data-v-1ae69322="" class="list">
              <div data-v-1ae69322="" class="lable">
                {{ $t('dingdanzhuangtai') }}
              </div>
              <div
                data-v-1ae69322=""
                class="list-content"
                v-if="item.status === 2"
              >
                {{ $t('yibaocang') }}
              </div>
              <div
                data-v-1ae69322=""
                class="list-content"
                v-if="item.status === 3"
              >
                {{ $t('yijisss') }}
              </div>
            </div>
            <div data-v-1ae69322="" class="list">
              <div data-v-1ae69322="" class="lable">{{ $t('yiungkuis') }}</div>
              <div
                data-v-1ae69322=""
                class="list-content"
                v-if="item.yk_status === 1"
              >
                {{ $t('ylll') }}{{ item.ylmoney }}
              </div>
              <div
                data-v-1ae69322=""
                class="list-content"
                v-if="item.yk_status === 2"
              >
                {{ $t('kuisss') }}{{ item.ylmoney }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-v-5e89786c="" class="empty-box"></div>
  </div>
</template>
<script>
import '../../assets/css/index-c925edae.css'
import '../../assets/css/514.cbfba8eb.css'
export default {
  data() {
    return {
      list: [],
      list2: [],
      showloading: false,
      selectop: 1,
      empty1: true,
      empty2: true,
      timer1: null,
      timer2: null,
    }
  },
  created() {
    this.showloading = true
    this.getlist()
    this.timer1 = setInterval(this.getlist, 6000)
  },
  beforeDestroy() {
    if (this.timer1) {
      clearInterval(this.timer1)
      this.timer1 = null
    }
    if (this.timer2) {
      clearInterval(this.timer2)
      this.timer2 = null
    }
  },
  beforeRouteLeave(to, from, next) {
    next()
    if (this.timer1) {
      clearInterval(this.timer1)
      this.timer1 = null
    }
    if (this.timer2) {
      clearInterval(this.timer2)
      this.timer2 = null
    }
  },
  methods: {
    async cancleorder(oid) {
      const { data } = await this.$http.post('/cancelcontractorder', {
        orderid: oid,
      })
      if (data) {
        if (data.code === 200) {
          this.$toast.success(this.$t('success'))
        } else {
          this.$toast.success(this.$t('fail'))
        }
      }
    },
    async pcorder(oid) {
      const { data } = await this.$http.post('/closingcontractorder', {
        orderid: oid,
      })
      if (data) {
        if (data.code === 200) {
          this.$toast.success(this.$t('success'))
          this.getlist()
        } else {
          this.$toast.success(this.$t('fail'))
        }
      }
    },
    changesel(e) {
      this.selectop = e
      if (e === 1) {
        this.showloading = true
        this.getlist()
        if (this.timer1) {
          clearInterval(this.timer1)
          this.timer1 = null
        }
        if (this.timer2) {
          clearInterval(this.timer2)
          this.timer2 = null
        }
        this.timer1 = setInterval(this.getlist, 6000)
      } else {
        this.showloading = true
        this.getlist2()
        if (this.timer1) {
          clearInterval(this.timer1)
          this.timer1 = null
        }
        if (this.timer2) {
          clearInterval(this.timer2)
          this.timer2 = null
        }
        this.timer2 = setInterval(this.getlist2, 6000)
      }
    },
    async getlist() {
      const { data } = await this.$http.post('/getcontracting')
      if (data) {
        this.list = data.data
        if (this.list.length > 0) {
          this.empty1 = false
        } else {
          this.empty1 = true
        }
      }
      this.showloading = false
    },
    async getlist2() {
      const { data } = await this.$http.post('/getcontractend')
      if (data) {
        this.list2 = data.data
        if (this.list2.length > 0) {
          this.empty2 = false
        } else {
          this.empty2 = true
        }
      }
      this.showloading = false
    },
  },
}
</script>
<style scoped lang="less">
.loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.no-data[data-v-a330c516] {
  width: 100%;
  height: 100%;
}
.no-data .no-img[data-v-a330c516] {
  width: 4rem;
  height: 4rem;
  background: #c0dd2b;
  border-radius: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  margin-top: 8rem;
}
.no-data .no-img img[data-v-a330c516] {
  width: 2rem;
}
.no-data .no-title[data-v-a330c516] {
  font-weight: 600;
  font-size: 2rem;
  color: #fff;
  margin: 0.5rem 0;
  height: 2rem;
  text-align: center;
}
.no-data .no-info[data-v-a330c516] {
  width: 18rem;
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.5rem;
  text-align: center;
  color: #a6a6a6;
  mix-blend-mode: normal;
  margin: auto;
}
</style>
